// extracted by mini-css-extract-plugin
export default {"tbBtnWrap":"Button_tbBtnWrap__+FCk-","tbBtnDiv":"Button_tbBtnDiv__mVHp3"};